/**
 * The presence cookie that decides what `featit.com/` shows (ADR-133, T-0344).
 *
 * The web app sets it when it holds a session and clears it on sign-out; the router's app block
 * reads it for the root alone: with it, the app (whose home is under `/-/`); without it, one 302 to
 * the website. It is not `HttpOnly` and carries no credential — the token stays in `localStorage` —
 * so it proves nothing, and a forged one only costs its sender a sign-in screen. It is the one
 * exception the "no cookies" rule (`oauth.controller.ts`) allows, because it chooses a page, never an
 * identity.
 *
 * ⛔ The name is also written in `infrastructure/router/nginx.conf` (`$cookie_featit_signed_in`),
 * which cannot import it; `scripts/tests/router-config.test.mjs` holds the two equal.
 */
export const SIGNED_IN_PRESENCE_COOKIE = 'featit_signed_in';

/** A year: the cookie outlives any one token, and a stale one costs a single hop to sign-in. */
const PRESENCE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

/** The `document.cookie` assignment that marks this browser signed in on this host. */
export function signedInPresenceCookie(secure: boolean): string {
  return `${SIGNED_IN_PRESENCE_COOKIE}=1; Path=/; Max-Age=${PRESENCE_MAX_AGE_SECONDS}; SameSite=Lax${
    secure ? '; Secure' : ''
  }`;
}

/** The `document.cookie` assignment that clears it. */
export function signedOutPresenceCookie(secure: boolean): string {
  return `${SIGNED_IN_PRESENCE_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure ? '; Secure' : ''}`;
}
